import type { CampaignData } from '@/schemas/v2/campaign'

export type CampaignPeriodStatus = 'before' | 'active' | 'after'

/**
 * キャンペーンデータと現在時刻をもとに期間ステータスを返す。
 *
 * - campaignData が null のとき: 'active'（ロード前・取得失敗時は通常表示）
 * - campaignStartAt が null のとき: 開始制限なし（開始前チェックをスキップ）
 * - campaignEndAt が null のとき: 終了制限なし（終了後チェックをスキップ）
 * - isTestMode が true でも期間チェックを行う（テストモードに関わらず開始前・終了後はメッセージを表示する）
 *
 * @param campaignData - キャンペーンデータ（null の場合は 'active' を返す）
 * @param now - テスト用に現在時刻を注入できるよう引数に持つ（省略時は new Date()）
 */
export function getCampaignPeriodStatus(
  campaignData: CampaignData | null,
  now: Date = new Date(),
): CampaignPeriodStatus {
  if (!campaignData) return 'active'

  const { campaignStartAt, campaignEndAt } = campaignData

  if (campaignStartAt && now < new Date(campaignStartAt)) return 'before'
  if (campaignEndAt && now > new Date(campaignEndAt)) return 'after'
  return 'active'
}
